/* src/app/components/okta-callback/okta-callback.component.scss */
/*# sourceMappingURL=okta-callback.component.css.map */
